<div class="row subscription-payment-edit__intro-row">
  <div class="col-12 subscription-payment-edit__intro-title">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('sub_payment_edit_intro')"
        [innerHTML]="translationService.getTranslation('sub_payment_edit_intro')"></h3>
  </div>
  <div class="col-12 subscription-payment-edit__intro-description"
       [innerHTML]="translationService.getTranslation('sub_payment_edit_description')">
  </div>
</div>

<mat-card class="mt-3 subscription-payment-edit__card">
  <mat-card-content class="subscription-payment-edit__card-content">
    @if (!isLoadingSub) {
      <div class="mb-5 subscription-payment-edit__sub-info">
        <div class="row subscription-payment-edit__sub-info-row">
          <div class="col-12 subscription-payment-edit__sub-info-product">
            {{ sub.productDescription }} / {{ sub.variantDescription }}
          </div>
        </div>
        @if (sub.backendId > 0) {
          <div class="row subscription-payment-edit__sub-info-row">
            <div class="col-12 subscription-payment-edit__sub-info-backendid"
                 [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.backendId">
            </div>
          </div>
        }
        @if (sub.curBilling) {
          <div class="row subscription-payment-edit__sub-info-row">
            <div class="col-12 subscription-payment-edit__sub-info-customer" [innerHTML]="translationService.getTranslation('customer') +
        ': ' + sub.curBilling.person.addressCodeDescription + ' ' +
        (sub.curBilling.person.titleDescription != '' ? sub.curBilling.person.titleDescription + ' ' : '') +
        sub.curBilling.person.firstname + ' ' +
        sub.curBilling.person.lastname">
            </div>
          </div>
        }
      </div>
    }

    @if (isLoadingSub) {
      <div style="text-align: center;" class="subscription-payment-edit__loading">
        <app-loading-spinner/>
      </div>
    }

    <app-general-errors class="subscription-payment-edit__errors" [errors]="errorsArr"></app-general-errors>

    @if (!isLoadingSub && changeNotPossible) {
      <div class="subscription-payment-edit__not-possible">
        {{ translationService.getTranslation('sub_payment_edit_change_not_possible') }}
      </div>
    }

    @if (!changeNotPossible) {
    <form class="subscription-payment-edit__form" [formGroup]="paymentEditForm">
      <div class="row subscription-payment-edit__form-row">

        <mat-form-field class="col-12 subscription-payment-edit__form-field" (click)="picker.open()"
                        formGroupName="validDate">
          <mat-label class="subscription-payment-edit__label"
                     [innerHTML]="translationService.getTranslation('startdate')"></mat-label>
          <input matInput [min]="minDate" [matDatepicker]="picker" readonly required formControlName="validFrom"
                 class="subscription-payment-edit__input">
          <mat-datepicker-toggle matSuffix [for]="picker"
                                 class="subscription-payment-edit__datepicker-toggle"></mat-datepicker-toggle>
          <mat-datepicker [touchUi]="isMobile" #picker class="subscription-payment-edit__datepicker"></mat-datepicker>
          @if (paymentEditForm.get('validDate').hasError('message')) {
            <mat-error class="subscription-payment-edit__error"
            >{{ paymentEditForm.get('validDate').getError('message') }}
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="col-12 subscription-payment-edit__form-field" formGroupName="paymentType">
          <mat-label class="subscription-payment-edit__label"
                     [innerHTML]="translationService.getTranslation('payment_type')"></mat-label>
          <mat-select formControlName="paymentMethod" required aria-required="true" [compareWith]="compareFormOfPayment"
                      [value]="paymentEditForm.get('paymentType.paymentMethod').value"
                      class="subscription-payment-edit__select">
            @for (formOfPayment of filteredFormsOfPayment; track formOfPayment) {
              <mat-option [value]="formOfPayment"
                          class="subscription-payment-edit__option">{{ formOfPayment.description }}
              </mat-option>
            }
          </mat-select>
          @if (paymentEditForm.get('paymentType.paymentMethod').hasError('message')) {
            <mat-error class="subscription-payment-edit__error">
              {{ paymentEditForm.get('paymentType.paymentMethod').getError('message') }}
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="col-12 subscription-payment-edit__form-field" formGroupName="paymentType">
          <mat-label class="subscription-payment-edit__label"
                     [innerHTML]="translationService.getTranslation('payment_rhythm')"></mat-label>
          <mat-select formControlName="paymentFrequency" required aria-required="true" [compareWith]="compareBaseData"
                      [value]="paymentEditForm.get('paymentType.paymentFrequency').value"
                      class="subscription-payment-edit__select">
            @for (paymentFrequency of filteredPaymentFrequencies; track paymentFrequency) {
              <mat-option [value]="paymentFrequency"
                          class="subscription-payment-edit__option">{{ paymentFrequency.description }}
              </mat-option>
            }
          </mat-select>
          @if (paymentEditForm.get('paymentType.paymentFrequency').hasError('message')) {
            <mat-error class="subscription-payment-edit__error">
              {{ paymentEditForm.get('paymentType.paymentFrequency').getError('message') }}
            </mat-error>
          }
        </mat-form-field>

        @if (needIbanBic) {
          <mat-form-field class="col-12 subscription-payment-edit__form-field">
            <mat-label class="subscription-payment-edit__label"
                       [innerHTML]="translationService.getTranslation('payment_bank_connection')"></mat-label>
            <mat-select formControlName="bankSelection" required aria-required="true"
                        class="subscription-payment-edit__select">
              @for (connection of availableBankConnections; track connection.bank.swiftIBAN) {
                <mat-option [value]="connection.bank.swiftIBAN" class="subscription-payment-edit__option">
                  {{ connection.bank.swiftIBAN | bankAccount }}
                </mat-option>
              }
            </mat-select>
            @if (paymentEditForm.get('bankSelection').hasError('message')) {
              <mat-error class="subscription-payment-edit__error">
                {{ paymentEditForm.get('bankSelection').getError('message') }}
              </mat-error>
            }
          </mat-form-field>
        }

        @if (needInvoiceMailAddress) {
          <mat-form-field class="col-12 subscription-payment-edit__form-field">
            <mat-label class="subscription-payment-edit__label"
                       [innerHTML]="translationService.getTranslation('payment_invoice_email')"></mat-label>
            <input matInput formControlName="invoiceEmail" required class="subscription-payment-edit__input">
            @if (paymentEditForm.get('invoiceEmail').hasError('message')) {
              <mat-error class="subscription-payment-edit__error">
                {{ paymentEditForm.get('invoiceEmail').getError('message') }}
              </mat-error>
            }
          </mat-form-field>
        }

        <div class="col-12 subscription-payment-edit__button-row">
          <button mat-raised-button color="primary" (click)="onSendPayment()"
                  [innerHTML]="translationService.getTranslation('button_send')"
                  class="subscription-payment-edit__button"></button>
        </div>
      </div>
    </form>
    }
  </mat-card-content>
</mat-card>
